import ConfirmButton from "@/component/common/button/ConfirmButton.tsx";
import { LICENSE_REGISTRATION_ENUM } from "@/constant/constants.ts";
import { LicenseRegistrationService } from "@/services/licenseRegistration/LicenseRegistrationService.ts";
import { toast } from "@/utils/toast.tsx";
import { useTranslation } from "react-i18next";

export const DeleteButton = ({
  record,
  research,
}: {
  record: LicenseRegistrationItemSearch;
  research: () => void;
}) => {
  const { t } = useTranslation();

  const handleDeleteLicense = async () => {
    const licenseId = record?.licenseRegistrationId;
    if (licenseId) {
      const res: SuccessResponse | null | undefined =
        await LicenseRegistrationService.delete(licenseId);
      if (res) {
        research();
        toast.success(res?.message || "Success");
      }
    }
  };

  const isDisabled = () => {
    return record.status !== LICENSE_REGISTRATION_ENUM.OVERDUE_RELEASE;
  };

  return (
    <ConfirmButton
      buttonText={t("button.delete")}
      buttonProps={{
        color: "danger",
        variant: "filled",
        disabled: isDisabled(),
      }}
      confirmMessage={t("message.confirmDeleteLicenseRegistration")}
      handleOk={handleDeleteLicense}
    />
  );
};
